(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('CardFormController', CardFormController);

    CardFormController.$inject = ['$scope', '$state', '$rootScope',  '$stateParams', 'entity',  'PaymentService', 'Account'];

    function CardFormController($scope, $state, $rootScope,  $stateParams, entity,  PaymentService, Account ) {
        var vm = this;


        vm.userPrice = 30;
        vm.userPriceOne = 50;
        vm.payment = {amount:3};

        vm.payment.instance = entity.instance;

        var elements = stripe.elements();

        vm.totalCost = 0;//?():vm.userPriceOne;

        if(vm.payment.amount == 1){
            vm.totalCost = vm.userPrice*vm.payment.amount;
        }
        else{
            vm.totalCost = vm.userPriceOne;
        }


        function getAccountThen (account) {
            vm.account = account.data;
            vm.payment.email = vm.account.email;
        }

        Account.get().$promise.then(getAccountThen);


        $scope.loadForm = function loadForm() {





            var style = {
                base: {
                    iconColor: '#666EE8',
                    color: '#31325F',
                    fontWeight: 300,
                    fontFamily: 'Ubuntu, sans-serif',
                    fontSize: '14px',
                    '::placeholder': {
                        color: '#CFD7E0',
                    },
                },
            };

            vm.cardNumberElement = elements.create('cardNumber', {
                style: style
            });
            vm.cardNumberElement.mount('#card-number-element');

            vm.cardExpiryElement = elements.create('cardExpiry', {
                style: style
            });
            vm.cardExpiryElement.mount('#card-expiry-element');

            vm.cardCvcElement = elements.create('cardCvc', {
                style: style
            });
            vm.cardCvcElement.mount('#card-cvc-element');

            vm.cardNumberElement.on('change', function(event) {
                // setOutcome(event);
            });

// Handle form submission.
            var form = document.getElementById('payment-form');
            form.addEventListener('submit', function (event) {
                event.preventDefault();

                var options = {
                    address_zip: document.getElementById('postal-code').value
                };

                stripe.createToken(vm.cardNumberElement, options).then(function (result) {
                    if (result.error) {
                        // Inform the user if there was an error.
                        //var errorElement = document.getElementById('card-errors');
                        //errorElement.textContent = result.error.message;
                        $scope.cardError = result.error.message;
                        vm.error = 'error';
                        vm.cardNumberElement.clear();
                        vm.cardExpiryElement.clear();
                        vm.cardCvcElement.clear();

                    } else {
                        // Send the token to your server.
                        stripeTokenHandler(result.token);
                    }
                });
            });




        }


        function setOutcome(result) {
            if (result.error) {
                $scope.cardError = result.error.message;
                }
            else{
                $scope.cardError = null;
            }

        }

        function stripeTokenHandler(token) {
            // Submit the form
            //form.submit();
            vm.error = null;
            $scope.cardError = null;
            vm.errorUsers = null;
            vm.isSaving = true;
            vm.payment.token = token.id;
            PaymentService.sendPayment(vm.payment).then(function (response) {
                vm.success = 'OK';
                vm.isSaving = false;
                $state.go('subscription-dbh');

            }).catch(function (response) {

                if (response.status === 500 && angular.fromJson(response.data).detail === "users") {
                    vm.errorUsers = 'ERROR';
                }
                else{
                    vm.error = 'ERROR';
                }
                vm.isSaving = false;

                vm.cardNumberElement.clear();
                vm.cardExpiryElement.clear();
                vm.cardCvcElement.clear();
            });
        }


        $scope.loadForm();

    }
})();
